import React from "react";
import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider, useAuth } from "@/context/AuthContext";
import { QuestionnaireProvider } from "@/context/QuestionnaireContext";

import Landing from "@/pages/Landing";
import Privacy from "@/pages/Privacy";
import Test from "@/pages/Test";
import Completato from "@/pages/Completato";
import Resume from "@/pages/Resume";

import Login from "@/pages/staff/Login";
import Dashboard from "@/pages/staff/Dashboard";
import ClienteDetail from "@/pages/staff/ClienteDetail";

const StaffRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-[100dvh] grid place-items-center bg-background">
        <div className="h-8 w-8 rounded-full border-2 border-foreground/20 border-t-foreground animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/staff/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <QuestionnaireProvider>
          <BrowserRouter>
            <Routes>
              {/* Client area (public) */}
              <Route path="/" element={<Landing />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/test" element={<Test />} />
              <Route path="/completato" element={<Completato />} />
              <Route path="/c/:id" element={<Resume />} />

              {/* Staff area (private) */}
              <Route path="/staff/login" element={<Login />} />
              <Route path="/staff/dashboard" element={<StaffRoute><Dashboard /></StaffRoute>} />
              <Route path="/staff/cliente/:id" element={<StaffRoute><ClienteDetail /></StaffRoute>} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" />
        </QuestionnaireProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
